/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDeletedByResponse
 */
export interface ControlDeletedByResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedByResponse
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedByResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedByResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedByResponse
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedByResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedByResponse
     */
    last_name?: string;
}

/**
 * Check if a given object implements the ControlDeletedByResponse interface.
 */
export function instanceOfControlDeletedByResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "client_id" in value;

    return isInstance;
}

export function ControlDeletedByResponseFromJSON(json: any): ControlDeletedByResponse {
    return ControlDeletedByResponseFromJSONTyped(json, false);
}

export function ControlDeletedByResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDeletedByResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'email': json['email'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
    };
}

export function ControlDeletedByResponseToJSON(value?: ControlDeletedByResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'email': value.email,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

